module.exports = __webpack_public_path__ + "static/media/brands_BGP.9734cee5.svg";